import { createContext, useContext, type MutableRefObject } from 'react';

import type { CustomSkillRecord } from '../../../queries/chats';

export type SettingsPanelCloseGuard = () => boolean | Promise<boolean> | void;

export type SettingsPanelView =
  | { type: 'outlook-manage' }
  | { type: 'nova-schedule-detail'; scheduleUuid: string }
  | { type: 'custom-skill-create' }
  | { type: 'custom-skill-edit'; skill: CustomSkillRecord };

interface SettingsPanelContextValue {
  pushView: (view: SettingsPanelView) => void;
  popView: () => void;
  backHandlerRef: MutableRefObject<SettingsPanelCloseGuard | null>;
}

const SettingsPanelContext = createContext<SettingsPanelContextValue | null>(null);

export function useSettingsPanelContext(): SettingsPanelContextValue {
  const context = useContext(SettingsPanelContext);
  if (!context) {
    throw new Error('useSettingsPanelContext must be used within a ChatSettingsPanel');
  }
  return context;
}

export function useSettingsPanelContextSafe(): SettingsPanelContextValue | null {
  return useContext(SettingsPanelContext);
}

export { SettingsPanelContext };
